import { Button, Grid, Typography, TextField, Box, Hidden
    , FormControl, InputLabel, Select, IconButton, Autocomplete } from "@mui/material";
import { Search as IconSearch, IndeterminateCheckBox as IconIndeterminateCheckBox
    , CheckBox as IconCheckBox } from "@mui/icons-material";
import * as sesionService from "../../services/sesionService";
import * as periodoService from "../../services/periodoService";
import * as catalogoService from "../../services/catalogoService";
import * as personaService from "../../services/personaService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";
import { setValue, setListTerapeutas, setListPeriodos, setListEstados } from '../../redux/sessionSearchSlice';
import { setPersonList } from "../../redux/personSlice";
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"
import { useMantenimiento } from "../../hooks/useMantenimiento";

const Index = () => {
    const { isReadOnly } = useMantenimiento("sesion");
    const filters = useSelector((state) => state.sessionSearch.filters);
    const listTerapeutas = useSelector((state) => state.sessionSearch.listTerapeutas);
    const listPeriodos = useSelector((state) => state.sessionSearch.listPeriodos);
    const listEstados = useSelector((state) => state.sessionSearch.listEstados);

    const [openDialogAnnulActive, setOpenDialogAnnulActive] = useState(false)
    const openCloseDialogAnnulActive = () => { setOpenDialogAnnulActive(!openDialogAnnulActive); }
    const [selectId, setSelectId] = useState(null);
    const [selectState, setSelectState] = useState(null);

    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();

    const fetchResults = async () => {
        setCargando(true);

        await sesionService.getsSesionResumenView(filters)
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchTerapeutas = async () => {
        const data = await personaService.getsListNaturalPersonByTypeAndName(25, "")
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });

        dispatch(setListTerapeutas(data));
    }
    const fetchPeriodos = async () => {
        await periodoService.getsPeriodoView({
                idTipoTerapia: 0,
                idEstadoApertura: 87,
                mesesHaciaAtras: 0,
                idEstado: 2,
            })
            .then((data) => {
                dispatch(setListPeriodos(data));
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const fetchEstados = async () => {
        await catalogoService.getCatalogosByPadre(1)
            .then((data) => {
                dispatch(setListEstados(data));
                dispatch(setValue({name: "idEstado", value: 2}))
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }
    const annul = async () => {
        await sesionService.annulSesion(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }
    const active = async () => {
        await sesionService.activeSesion(selectId)
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err);
            });
            fetchResults();
    }

    useEffect(() => {
        fetchResults();
        fetchTerapeutas();
        fetchPeriodos();
        fetchEstados();
    }, []);

    const columns = [
        { field: 'participante', headerName: 'Participante', width: 150, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/session/edit/' + cellValues.row.id + '/' +  + cellValues.row.idTerapiaPeriodo} style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        { field: 'fecha', headerName: 'Fecha', width: 100, type: 'date'
            , valueFormatter: (value) => moment(value).format('D/MM/YYYY')
            , sortable: false, headerAlign: 'center', align: 'center' },
            { field: 'codigoPeriodo', headerName: 'Periodo', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'terapeuta', headerName: 'Terapeuta', width: 180, sortable: false, headerAlign: 'center' },
        { field: 'estado', headerName: 'Estado', width: 80, sortable: false, headerAlign: 'center' },
        { field: 'anular', headerName: '', width: 80, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                return <IconButton aria-label="anular" size='small' style={{height: 10}} align={"center"} disabled={isReadOnly} onClick={() => {
                    setSelectId(cellValues.row.id);
                    setSelectState(cellValues.row.estado);
                    setOpenDialogAnnulActive(true);
                }}>
                    { cellValues.row.estado == "A" ? <IconIndeterminateCheckBox /> : <IconCheckBox /> }
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container>
                <Grid item>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Sesiones
                    </Typography>
                </Grid>
                <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container item xs={12} sm={12} spacing={1} padding={0}>
                            <Grid item xs={12} sm={2} >
                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="idTerapeuta"
                                        value={filters.idTerapeuta == null ? 0 : filters.idTerapeuta}
                                        inputValue={filters.terapeuta == null ? "" : filters.terapeuta}
                                        onInputChange={(event, newValue) => {
                                            if (event != null) {
                                                if (event.type === "change") {
                                                    dispatch(setValue({name: "terapeuta", value: newValue == null ? "" : newValue}))
                                                }
                                            }
                                        }}
                                        onChange={(event, newValue) => {
                                            dispatch(setValue({name: "idTerapeuta", value: newValue == null ? 0 : newValue.id}))
                                            dispatch(setValue({name: "terapeuta", value: newValue == null ? "" : newValue.descripcion}))
                                        }}
                                        options={listTerapeutas}
                                        autoHighlight
                                        getOptionLabel={(option) => option.descripcion == null ? "" : option.descripcion}
                                        isOptionEqualToValue ={(option, value) => option.value === value.value}
                                        renderOption={(props, option) => {
                                            return (
                                                <li {...props} key={option.id}>
                                                {option.descripcion}
                                                </li>
                                            );
                                            }}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Terapeuta"
                                                variant="outlined"
                                                inputProps={{
                                                    ...params.inputProps,
                                                    autoComplete: 'new-password',
                                                }}
                                            />
                                        )}
                                        size="small"
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <TextField
                                    name="participante"
                                    label="Participante"
                                    value={filters.participante}
                                    fullWidth
                                    onChange={(event) => {
                                        dispatch(setValue({name: "participante", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-periodo">Periodo</InputLabel>
                                    <Select
                                        native
                                        label="Periodo"
                                        value={filters.idPeriodo}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idPeriodo", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idPeriodo',
                                            id: 'input-periodo',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listPeriodos.map((row) => (
                                            <option key={row.id} value={row.id}>{row.codigo}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <TextField
                                    required
                                    name="fechaInicio"
                                    label="Inicio"
                                    fullWidth
                                    type="date"
                                    value={moment(filters.fechaInicio).format('yyyy-MM-DD')}
                                    onChange={(event) => {
                                        dispatch(setValue({name: "fechaInicio", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <TextField
                                    required
                                    name="fechaFin"
                                    label="Fin"
                                    fullWidth
                                    type="date"
                                    value={moment(filters.fechaFin).format('yyyy-MM-DD')}
                                    onChange={(event) => {
                                        dispatch(setValue({name: "fechaFin", value: event.target.value}))
                                    }}
                                    onKeyDown={(event) => {
                                        if (event.key === "Enter") {
                                            event.preventDefault();
                                            fetchResults();
                                        }
                                    }}
                                    size="small"
                                />
                            </Grid>
                            <Grid item xs={6} sm={2}>
                                <FormControl fullWidth>
                                    <InputLabel htmlFor="input-estado">Estado</InputLabel>
                                    <Select
                                        native
                                        label="Estado"
                                        value={filters.idEstado}
                                        onChange={(event) => {
                                            dispatch(setValue({name: "idEstado", value: event.target.value}))
                                        }}
                                        onKeyDown={(event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                fetchResults();
                                            }
                                        }}
                                        inputProps={{
                                            name: 'idEstado',
                                            id: 'input-estado',
                                        }}
                                        size="small"
                                    >
                                        <option key={0} value={0}>{"(Todos)"}</option>
                                        {listEstados.map((row) => (
                                            <option key={row.id} value={row.id}>{row.descripcion}</option>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6} sm={1} display={"flex"} alignItems={"center"}>
                                <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                    fetchResults()
                                }}>
                                    {<Hidden smDown></Hidden>}
                                    <IconSearch />
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                            <DataGridBase
                                rows={results}
                                columns={columns}
                                loading={cargando}
                                disabled={isReadOnly}
                                // hideNewButton={false}
                            />
                        </Box>
                    </Grid>
                    <DialogYesNo open={openDialogAnnulActive} openClose={openCloseDialogAnnulActive} setYes={ selectState == "A" ? annul : active} 
                        setNo={() => { return }}
                        titulo={(selectState == "A" ? "Anular" : "Activar") + " Sesion"}
                        texto={"Esta seguro de " + (selectState == "A" ? "anular" : "activar") + " la sesion?"} >
                    </DialogYesNo>
                </Grid>
            </Grid>
        </div>
    )
}
export default Index


